import axios from 'axios';

class InfluencerService {

  constructor(baseURL, timeout, paramHeaders) {
    const headers = paramHeaders;
    if (!headers.Accept) { headers.Accept = 'application/json'; }
    this.influencerService = axios.create({
      baseURL,
      timeout,
      headers,
    });
  }

  getInfluencers(params) {
    this.influencerService.defaults.baseURL = 'https://influencers.dyzio.co/';
    return this.influencerService.post('api/v2/influencers/search', params)
      .then(response => response.data)
      .catch(error => error);
  }

  getInfluencer(slug) {
    this.influencerService.defaults.baseURL = 'https://dorem01008kpi.cloudfront.net/';
    return this.influencerService.get(`influencerprofiles/slug/${slug}`)
      .then(response => response.data)
      .catch(error => error);
  }

  getTrendingInfluencers() {
    this.influencerService.defaults.baseURL = 'https://dorem01008kpi.cloudfront.net/';
    return this.influencerService.get('api/v2/influencers/trending')
      .then(response => response.data)
      .catch(error => error);
  }

  getInstagramFeed(handle){
    this.influencerService.defaults.baseURL = 'https://dorem01008kpi.cloudfront.net/';
    return this.influencerService.get(`influencerprofiles/slug/${handle}/instagram`)
      .then(response => response.data)
      .catch(error => error);
  }
}

export const influencerService = new InfluencerService('https://dorem01008kpi.cloudfront.net/', 5000, {});



// WEBPACK FOOTER //
// ./src/services/influencer-service.js